<template>
  <my-view :GetOrderList="GetOrderList" :ExportExcel="ExportExcel" :CompleteOrderBatch="CompleteOrderBatch" :OverTimecancelOrder="OverTimecancelOrder" :GetCancelOrder="GetCancelOrder" :CancelOrder="CancelOrder" :BatchAddShopCart="BatchAddShopCart"></my-view>
</template>

<script>
import {
  GetOrderList,
  ExportExcel,
  CompleteOrderBatch,
  OverTimecancelOrder,
  GetCancelOrder,
  CancelOrder,
} from "@/pages/page1/api/modules/order";
import { BatchAddShopCart } from "@/pages/page1/api/modules/shoppingCart";

import MyView from "@/pages/publicView/personalCenter/myOrder_view.vue";

export default {
  components: { MyView },
  data() {
    return {
      GetOrderList,
      ExportExcel,
      CompleteOrderBatch,
      OverTimecancelOrder,
      GetCancelOrder,
      CancelOrder,
      BatchAddShopCart,
    };
  },
};
</script>